<template>
  <div ref="tooltipEl">
    <slot></slot>
    <div class="tooltip_bg"></div>
  </div>
</template>

<script>
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css"; // Optional: for default styling

export default {
  data() {
    return {
      tooltipInstance: null, // To store the Tippy instance
    };
  },

  props: {
    text: {
      type: String,
      default: "",
    },
    position: {
      type: String,
      default: "top",
    },
    size: {
      type: String,
      default: "small",
    },
  },

  mounted() {
    this.tooltipInstance = tippy(this.$refs.tooltipEl, {
      content: this.text,
      allowHTML: true,
      placement: this.position,
      theme: "custom",
      hideOnClick: false,
    });
  },

  watch: {
    text(newText) {
      if (this.tooltipInstance) {
        this.tooltipInstance.setContent(newText);
      }
    },
  },

  beforeDestroy() {
    if (this.tooltipInstance) {
      this.tooltipInstance.destroy();
    }
  },
};
</script>
